import { createContext } from "react";
import { sponsorsInitialState } from "./sponsorsInitialState";


const SponsorsContext = createContext(sponsorsInitialState)

export default SponsorsContext